import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import {
  getJoinIntroDeeplinkParams,
  getSafeAppRedirectPath,
} from 'helpers/url';

const guestSearchSchema = z.object({
  continue: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_layoutAuth/_guest')({
  validateSearch: guestSearchSchema,
  beforeLoad: async ({ context, location, search }) => {
    const { user } = context;

    if (user) {
      const searchStr =
        typeof location.searchStr === 'string' ? location.searchStr : '';

      // A logged-in user following an external "request an intro" join link
      // never reaches the join page (this guard bounces them), so the
      // deeplink it carries would be lost. Send them straight where the
      // post-signup flow lands preregistered users: the trending
      // recommendation with the intro-request dialog open (BAN-5923).
      if (location.pathname.startsWith('/join')) {
        const deeplink = getJoinIntroDeeplinkParams(
          searchStr,
          user.roles?.[0]?.team_slug,
        );
        if (deeplink) {
          throw redirect({
            params: deeplink,
            replace: true,
            search: { dialog: 'introduction-request' },
            to: '/teams/$teamId/trending/$recommendationId',
          });
        }
      }

      const fromSearch =
        typeof search.continue === 'string' ? search.continue : undefined;
      const fromUrl =
        fromSearch ??
        new URLSearchParams(searchStr).get('continue') ??
        undefined;
      const continuePath = getSafeAppRedirectPath(fromUrl);
      throw redirect({ replace: true, to: continuePath ?? '/' });
    }
  },
  component: Outlet,
});
